import { LayoutOffset } from './layoutTypes';

const numberToOffset = (offset: number) => ({
  horizontal: offset,
  vertical: offset,
} as LayoutOffset);

export default numberToOffset;
